import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environment";
import { Observable } from "rxjs";
import {
  AutoForecastValidation,
  PatientForecast,
  PatientForecastEdit,
  PatientForecastInsert,
  PatientForecastListItem,
} from "../interfaces/forecast.interface";
import { SkipSpinnerService } from "./skip-spinner.service";

@Injectable({ providedIn: "root" })
export class ForecastClient {
  endpoint = "patient";

  constructor(private httpClient: HttpClient, private skipSpinnerService: SkipSpinnerService) {}

  getPatientForecastList(facilityId: string, patientId: string) {
    return this.httpClient.get<PatientForecastListItem[]>(
      `${environment.endpoint}/${this.endpoint}/get-patient-forecast-list/${facilityId}/${patientId}`
    );
  }

  getPatientForecastByDate(
    facilityid: string,
    patientid: string,
    fromDate: string,
    toDate: string,
    skipSpinner: boolean = false
  ) {
    const options = this.skipSpinnerService.getHeaders(skipSpinner);
    return this.httpClient.get<PatientForecast>(
      `${environment.endpoint}/${this.endpoint}/get-patient-forecast-by-date`,
      {
        params: {
          facilityid,
          patientid,
          fromDate,
          toDate,
        },
        headers: options
      }
    );
  }

  savePatientForecast(facilityId: string, patientId: string, addItems: PatientForecastInsert[], editItems: PatientForecastEdit[]) {
    return this.httpClient.post(`${environment.endpoint}/${this.endpoint}/save-patient-forecast-list`,
      {
        facilityId,
        patientId,
        patientForecastInserts: addItems,
        patientForecastEdits: editItems
      }
    );
  }

  editPatientForecastLastEstimatedTx(
    patienttherapyforecastid: number,
    estimatedlasttx: string
  ) {
    this.httpClient.post(
      `${environment.endpoint}/${this.endpoint}/edit-patient-forecast-last-estimated-tx`,
      {},
      {
        params: {
          patienttherapyforecastid,
          estimatedlasttx,
        },
      }
    );
  }

  validateAutoForecast(
    patientFacilityId: number,
    startDate: string,
    numberOfWeeks: number
  ): Observable<AutoForecastValidation> {
    return this.httpClient.get<AutoForecastValidation>(
      `${environment.endpoint}/${this.endpoint}/validate-auto-forecast`,
      {
        params: {
          patientfacilityid: patientFacilityId,
          startdate: startDate,
          numweeks: numberOfWeeks,
        },
      }
    );
  }

  getPatientMedicare100thday(patientFacilityId: number) : Observable<string> {
    return this.httpClient.get<string>(
      `${environment.endpoint}/${this.endpoint}/get-patient-medicare-100th-day`,
      { params: {patientfacilityid: patientFacilityId,}, }
    );
  }
}
